import React from 'react'
import { Link } from 'react-router-dom'

import DeleteIcon from 'Assets/Images/icons/delete'

export const LinkDeleteUnstyled = props => (
  <div
    className={props.className}
    onClick={props.onClickHandler}
    cypress_id={props.cypress_id}
  >
    <DeleteIcon />
    <Link to={props.to || ''} />
  </div>
)
